import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../../../util/Localizer'
import NoResultsMsg from '../../../../widgets/common/NoResultsMsg'

class Coinsurance extends Component {
  render () {
    let coinsuranceArray = this.props.data
    return (
      <div>
        {coinsuranceArray.length > 0 ? (
          <Row>
            <Col>
              <ul>
                {coinsuranceArray.map((item, i) => { return <li key={i}>{item.description}</li> })}
              </ul>
            </Col>
          </Row>
        ) : (
          <NoResultsMsg message={localize('pages.benefitDetails.coinsurance.empty')} />
        )}
      </div>
    )
  }
}

export default Coinsurance



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/Coinsurance.js